import { appConfig as $config } from '../../app.config';
import { UI } from '../UI';
import { fUploader } from '../fUploader';

export const CloudUploader = (function () {
  let $fup = null;

  const mapping = {
    result: (data) => {
      return data.map((file) => {
        return {
          ...file,
          ...{
            date: moment().format($config.appFullDateFormat),
            image: file.file.type && file.file.type.split('/')[0] === 'image'
          }
        };
      });
    }
  };

  const dialog = () => {
    let template = require('./tmpl/upload-dialog.hbs');
    bootbox
      .dialog({
        title: 'Upload Files to F4NTEC Cloud',
        message: template({ $lang: $Lang }),
        size: 'large',
        className: 'modal-cloud-uploader',
        buttons: {
          ok: {
            label: $lang.btn.upload,
            className: 'btn btn-brand btn-cloud-uploader',
            callback: uploadStart
          },
          cancel: {
            label: $lang.btn.cancel,
            className: 'btn btn-link'
          }
        }
      })
      .init(dialogInit);
  };

  const uploadStart = (e) => {
    $fup.uploadStart();
    return false;
  };

  const dialogInit = () => {
    $fup = new fUploader('input.cloud-uploader-file', {
      limit: 20,
      extensions: ['png', 'ai', 'psd', 'pdf', 'tif', 'tiff'],
      suitabilityViewExtensions: ['png', 'ai', 'psd', 'pdf', 'tif', 'tiff'],
      pageType: 'Boms',
      blockEl: '.modal-cloud-uploader .modal-content',
      complete: completeDialog
    });
  };

  const completeDialog = (data) => {
    $('.modal-cloud-uploader').modal('hide');

    let template = require('./tmpl/complete-dialog.hbs');
    bootbox
      .dialog({
        title: 'Get files links',
        message: template({
          $lang: $Lang,
          data: mapping.result(data)
        }),
        size: 'xl',
        buttons: {
          cancel: {
            label: 'Go back to Ipmort BOM page',
            className: 'btn btn-brand'
          }
        }
      })
      .init(() => {
        $('.js-action-copylink').on('click', (e) => {
          let input = $(e.target).closest('.input-group').find('input');
          input.focus();
          input.select();
          try {
            let successful = document.execCommand('copy');
            if (successful) UI.notify({ text: 'Link copied to clipboard', type: 'success' });
            else UI.notify({ text: 'Oops, unable to copy', type: 'danger' });
          } catch (err) {
            UI.notify({ text: 'Oops, unable to copy', type: 'danger' });
          }
        });
      });
  };

  return {
    dialog
  };
})();
